export default "__VITE_ASSET__daa92083__"